import React, { useEffect, useState } from 'react'
import './NFTGallery.css'

const NFTGallery = () => {
	const [nfts, setNfts] = useState([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		const fetchNFTs = async () => {
			try {
				const res = await fetch('https://api.testnet.getgems.io/graphql', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'x-gg-client': 'v:1 l:en',
						Referer: 'https://testnet.getgems.io/',
					},
					body: JSON.stringify({
						operationName: 'nftSearch',
						variables: {
							query: JSON.stringify({
								$and: [
									{
										collectionAddress:
											'EQC2OsGzZk8OEgXCTJJA0w-wHcaX9BdixRTQfgIXi7ungELo',
									},
								],
							}),
							attributes: null,
							sort: JSON.stringify([
								{ isOnSale: { order: 'desc' } },
								{ price: { order: 'asc' } },
								{ index: { order: 'asc' } },
							]),
							count: 30,
						},
						extensions: {
							persistedQuery: {
								version: 1,
								sha256Hash:
									'c9c9eab431a93e6129d91b717415c30dff830bfd09e2f99ffa97d2ebc02ac971',
							},
						},
					}),
				})

				const json = await res.json()
				console.log('📦 FULL JSON RESPONSE:', json)

				const edges = json?.data?.alphaNftItemSearch?.edges

				if (!edges || !Array.isArray(edges)) {
					console.error('❌ Invalid response structure', json)
					setLoading(false)
					return
				}

				const parsedNFTs = edges.map(({ node }) => {
					const content = node?.content || {}
					const image =
						typeof content.image?.baseUrl === 'string'
							? content.image.baseUrl
							: null

					return {
						name: content.name || node.name || 'Untitled',
						image,
						description: content.description || '',
						address: node.address,
						owner: node?.owner?.wallet || 'Unknown',
						collectionName: node?.collection?.name || 'Unnamed Collection',
					}
				})

				setNfts(parsedNFTs)
				setLoading(false)
			} catch (e) {
				console.error('❌ Fetch error:', e)
				setLoading(false)
			}
		}

		fetchNFTs()
	}, [])

	if (loading) return <p className='nft-loading'>Loading collection...</p>

	return (
		<div className='nft-gallery-wrapper'>
			<h1 className='nft-heading'>Our NFT Collection</h1>
			<div className='nft-grid'>
				{nfts.map((nft, i) => (
					<div key={i} className='nft-card'>
						<img src={nft.image} alt={nft.name} className='nft-image' />
						<h3 className='nft-title'>{nft.name}</h3>
						<div className='nft-info'>
							<div>
								<span className='nft-label'>Owner:</span>
								<span
									className='nft-copyable'
									title='Click to copy'
									onClick={() => navigator.clipboard.writeText(nft.owner)}
								>
									{nft.owner}
								</span>
							</div>
							<div className='nft-row'>
								<span className='nft-label'>Collection:</span>
								{nft.collectionName === 'Fucken Me Collection' ? (
									<a
										href='https://testnet.getgems.io/collection/kQC2OsGzZk8OEgXCTJJA0w-wHcaX9BdixRTQfgIXi7ungPli'
										target='_blank'
										rel='noopener noreferrer'
										style={{
											color: '#ff7722',
											textDecoration: 'underline',
											marginLeft: '4px',
										}}
									>
										{nft.collectionName}
									</a>
								) : (
									<span style={{ marginLeft: '4px' }}>
										{nft.collectionName || 'Art Gallery'}
									</span>
								)}
							</div>

							<div>
								<span className='nft-label'>NFT Address:</span>
								<span
									className='nft-copyable'
									title='Click to copy'
									onClick={() => navigator.clipboard.writeText(nft.address)}
								>
									{nft.address}
								</span>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default NFTGallery
